
import { CarBodyType, CarGearBox, CarDoors, CarRefItemStatus } from "../constants/car-basic-data";
import { CarEngine } from "./car-engine.model";
import { CarFeature } from "./car-feature.model";

export class CarVersion {
    id: number = 0;
    
    code = '';
    name = '';
    details = '';

    modelId: number = 0;
    modelCode: string = '';
    modelName: string = '';

    makeId: number = 0;
    makeCode: string = '';
    makeName: string = '';

    // engineId: number = 0;
    // engineCode: string = '';
    // engineName: string = '';
    // engineFuelType: string = '';
    // enginePower: number = 0;

    // featureIds: number[] = [];
    // featureCodes: string[] = [];
    // featureNames: string[] = [];

    engines: CarEngine[] = [];
    features: CarFeature[] = [];

    bodyType: CarBodyType = CarBodyType.CABRIOLET
    gearBox: CarGearBox = CarGearBox.AUTO;
    doors: CarDoors = CarDoors.FOUR;

    startYear = 1900;
    endYear = 2099;
    
    status: CarRefItemStatus = CarRefItemStatus.REVIEW;
    created = '';
    lastUpdated = '';
    lastUpdatedBy = '';
  
    constructor (code: string, name: string)  {
        this.code = code!;
        this.name = name!;
    }

    isValid(): boolean {

        return this.modelId > 0 && this.makeId > 0 && this.engines.length > 0 && this.name.length > 0;
    }
  }
  
